import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../baseClasses/BaseComponent';

import Animate from '../../components/Animate';
import notificationBadge from '../../assets/images/notification-badge.svg';
import notificationIcon from '../../assets/images/notification-icon-light-gray.svg';
import NotificationCard from '../NotificationCard';
import ChronologicalItemList from '../../components/ChronologicalItemList';
import dataModel from '../../models/DataModel';
import Iconoclast from '../../components/Iconoclast';
import AnalyticsLogger from '../../helpers/analytics/analyticsLogger';

import './NotificationsPopup.scss';

export class NotificationsPopup extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      deleting: false,
      notifications: props.notifications,
    };
    this.unreadNotifications = {};
    this.createNotificationCard = this.createNotificationCard.bind(this);
    const currentRole = props.currentUser ? props.currentUser.role : null;

    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
  }

  componentDidMount() {
    if (this.focusElement) {
      this.focusElement.focus();
    }

    this.props.notificationsDataModel.markAllRead()
      .then(notifications => {
        this.setState(notifications);
      });
    delete localStorage.scrollPositionTasks;
    delete localStorage.scrollPositionCompletionStep;
    delete localStorage.scrollPosition;
    // Let google analytics know
    this.analyticsLogger.logNotifications('NotificationsBell');
  }

  componentDidUpdate(prevProps) {
    if (prevProps.notifications != this.props.notifications) {
      this.setState({ notifications: this.props.notifications });
    }
  }

  /**
   * EVENT HANDLERS
   */
  
  handleAnimateClose() {
    this.setState({ closePopup: true });
  }

  handleAnimateComplete() {
    if (this.props.closeCallback) {
      this.props.closeCallback();
    }
  }

  handleBackgroundClick() {
    this.handleAnimateClose();
  }

  handleCollapseSectionComplete() {
    this.setState({
      deleting: false,
      section: null,
    });
  }

  handleDeleteAllNotifications() {
    this.setState({ notifications: [] });
    this.props.notificationsDataModel.markAllActedOn()
      .catch(error => {
        this.setState({ notifications: this.props.notifications });
      });
    this.handleAnimateClose();
  }

  handleKeyDown(e) {
    if (e.keyCode == 27) {
      e.preventDefault();
      this.handleAnimateClose();
    }
  }

  handlePrepareDelete(section) {
    // if (
    //   this.dateCategories[section] &&
    //   this.dateCategories[section].length == 1
    // ) {
    this.setState({
      section: section,
      deleting: true,
    });
    // }
  }

  handlePromptDeleteAll() {
    let message =
      'Are you sure you want to delete all your Notifications? This action cannot be undone.';
    this.props.dataModel.showGlobalModal('SYSTEM_POPUP', {
      message: message,
      cancelButtonText: this.textMap.cancel.toUpperCase(),
      okButtonText: this.textMap.delete.toUpperCase(),
      width: 320,
      height: 184,
      handleOwnerOk: () => {
        this.handleDeleteAllNotifications();
      },
    });
  }

  handleStopPropagation(e) {
    e.stopPropagation();
  }

  handleUpdateNotification(notification) {
    if(notification){
      this.props.notificationsDataModel.notification = {
        actedOn: notification,
        collection: true,
      };
    }
    // this.setState({ displayNotifications: false })
    this.setState({ closePopup: true });
  }

  handleSelectNotification(notification){
    if(notification){
      if(this.state.selectedNotification && this.state.selectedNotification.id == notification.id){
        this.setState({ selectedNotification: null });
      }
      this.setState({ selectedNotification: notification });
    }
  }

  /**
   * RENDERING FUNCTIONS
   */

  createNotificationCard(notification, section) {
    let unreadClass = '';
    let badge = null;
    let selected = 
      this.state.selectedNotification && 
      this.state.selectedNotification.id == notification.id;

    if (!notification.read_at) {
      this.unreadNotifications[notification.id] = notification;
      badge = (
        <img
          className="notification-badge faded"
          src={notificationBadge}
          alt=""
        />
      );
    }
    if (this.unreadNotifications[notification.id]) {
      badge = (
        <img
          className="notification-badge faded"
          src={notificationBadge}
          alt=""
        />
      );
    }

    //TODO: make notifications service that contains the data models
    return (
      <NotificationCard
        unreadClass={unreadClass}
        badge={badge}
        key={'notification-' + notification.id}
        notification={notification}
        handleUpdateNotification={this.handleUpdateNotification}
        section={section}
        prepareDelete={this.handlePrepareDelete}
        handleSelectNotification={this.handleSelectNotification}
        selected={selected}
        isMobile={this.props.isMobile}
      />
    );
  }

  render() {
    let { right, top } = this.props;

    let style = {};
    if (!dataModel.mobileBridge.isMobile) {
      if (right) {
        style.right = right + 'px';
      }
      if (top) {
        style.top = top + 'px';
      }
      if (this.props.dontAnimate) {
        style.height = 508;
      }
    }

    const notificationsHidden = dataModel.isOffline && dataModel.mobileBridge.isMobile ? ' notifications-popup-inner--hidden' : '';

    return (
      <div
        className={
          'notification-background' +
          (this.props.dontAnimate ? ' no-background' : '')
        }
        onClick={this.handleBackgroundClick}
        onKeyDown={this.handleKeyDown}
        ref={element => {
          this.focusElement = element;
        }}
      >
        <div
          id="notifications-popup"
          className="notifications-popup"
          style={style}
          onClick={this.handleStopPropagation}
          onKeyDown={this.handleKeyDown}
        >
          {!dataModel.mobileBridge.isMobile &&
            !this.props.dontAnimate && (
              <Animate
                key="animate-card-in"
                component_id="notifications-popup"
                duration={250}
                property={{
                  height: {
                    startVal: 0,
                    endVal: 508,
                  },
                }}
              />
            )}
          {this.state.section && (
            <Animate
              key="animate-section-out"
              component_id={this.state.section}
              duration={500}
              property={{
                height: {
                  startVal: 66,
                  endVal: 0,
                },
              }}
              onUnmount={false}
              completionCallback={this.handleCollapseSectionComplete}
            />
          )}
          {!dataModel.mobileBridge.isMobile &&
            !this.props.dontAnimate &&
            this.state.closePopup && (
              <Animate
                key="animate-card-out"
                component_id="notifications-popup"
                duration={250}
                property={{
                  height: {
                    startVal: 508,
                    endVal: 0,
                  },
                }}
                completionCallback={this.handleAnimateComplete}
              />
            )}
          {!dataModel.mobileBridge.isMobile && (
            <div className="notification-header">
              <div className="notifications-title">Notifications</div>
          </div>
          )}
          {
            notificationsHidden != '' 
            && <div className='notifications-offline'>
              <Iconoclast type={'offline-double'} color='#9b9b9b' />
              <p>Application data could not be retrieved. Please check your internet connection.</p>
            </div>
          }
          <div className={'notifications-popup-inner' + notificationsHidden}>
            <div className='notifications-popup-scroller'
              onKeyDown={this.handleKeyDown} >
              <div className='notifications-popup-contents'
                onKeyDown={this.handleKeyDown
                  //TODO: maybe extract emptyList props 
                }>
                <ChronologicalItemList
                  canDeleteItems={true}
                  emptyListClass="empty-notifications"
                  emptyListIcon={notificationIcon}
                  getItemCard={this.createNotificationCard}
                  handleDeleteAllItems={this.handleDeleteAllNotifications}
                  items={this.state.notifications}
                  itemsName="Notifications"
                  selected={this.state.selectedNotification}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    notifications: state.notifications.notifications,
    allNotifications: state.notifications.allNotifications,
    notificationsDataModel: dataModel.notificationsDataModel,
    permissions: state.new_users.permissions,
    currentUser: state.new_users.currentUser,
    dataModel: dataModel,
    mobileBridge: dataModel.mobileBridge,
  };
};

export default connect(mapStateToProps, null)(NotificationsPopup);



// WEBPACK FOOTER //
// ./src/components/NotificationsPopup/index.js